import * as Schemas from './properties'

const showErrorMessageInConsole = (description: string, errors: string) => console.error(`${description}: ${errors}`)

export {Schemas, showErrorMessageInConsole}
